import { createApp } from 'vue'
import { createRouter, createWebHistory } from 'vue-router'
import { createPinia } from 'pinia'
import App from './App.vue'
import routes, { setupRouterGuards } from './router'

// Import design system styles
import './styles/design-system.css'

try {
  const app = createApp(App)

  // Setup state management
  const pinia = createPinia()
  app.use(pinia)

  // Setup router
  const router = createRouter({
    history: createWebHistory(),
    routes
  })

  // Setup router guards (must be after pinia is installed)
  setupRouterGuards(router)

  app.use(router)

  app.mount('#app')
  console.log('[Main] App mounted successfully')
} catch (error) {
  console.error('[Main] Failed to mount app:', error)
  document.body.innerHTML = `
    <div style="padding: 20px; color: red; font-family: monospace;">
      <h1>Application Error</h1>
      <pre>${error instanceof Error ? error.message : String(error)}</pre>
      <pre>${error instanceof Error ? error.stack : ''}</pre>
    </div>
  `
}
